import { ServiceBagService } from '@base/component/ServiceBag';
import { BaseInjectableComponent } from '@base/component/BaseInjectableComponent';
import { EnumCRUDActions, EnumToggle, EnumLoginExtensionLinkType, EnumMessageBoxTypes, EnumWindowSizes, EnumPrintingType } from '@core/framework/sysenums.enum';
import { BasePageComponent } from '../component/BasePageComponent';
import { BaseDataSourceAbstract } from '../datalayer/BaseDataSourceAbstract';
import { BaseEntity, BaseState, DataGroupInfo } from '../entities/BaseEntities';
import { GridExtender } from '../grid/Grid.extender';
import { TemplateRef } from '@angular/core';
import { BaseComponent } from '../component/BaseComponent';

export class StringMapElement {
    Old: string;
    New: string;
}

export class BaseCustomizationElementFilter {
    Component: string | string[];
    Name: string | string[];
    User: number | number[];
}

export class BaseCustomizationElementLogic {
    Hide: boolean;
    HideOnMobile: boolean;
    HideOnDesktop: boolean;
}

export class BaseCustomizationElement {
    Filter: BaseCustomizationElementFilter;
    Logic: BaseCustomizationElementLogic;
}

export class FieldCustomizationElementLogic extends BaseCustomizationElementLogic {
    ReadOnly: boolean;
    Required: boolean;
    Label: string;
    DefaultValue: string;
    HideValues: string[];
    ValidationFunction: (Entity: BaseEntity, State: BaseState) => boolean;
    ValidationMessage: string;
}

export class ComponentCustomizationElementFilter extends BaseCustomizationElementFilter {
    Columns: string[];
}

export class FieldCustomizationElement extends BaseCustomizationElement {
    override Logic: FieldCustomizationElementLogic;
}

export class ComponentCustomization extends BaseCustomizationElement {
    override Filter: ComponentCustomizationElementFilter;
}

export class EntitySavedEventArgs {
    constructor(
        public Entity: BaseEntity,
        public Type: new () => BaseEntity,
        public Action: EnumCRUDActions
    ) {
    }
}

export class EntityLoadedEventArgs {
    constructor(
        public Entity: BaseEntity,
        public Type: new () => BaseEntity,
    ) {
    }
}


export class ViewModeElement {
    viewmode: any;
    visible?: boolean;
    text: string;
    callback: any;
}

export class ContextMenuElement {
    constructor(
        public text: string,
        public onClick: () => any,
        public visible?: boolean | (() => boolean),
        public icon?: string
    ) { }
}

export class MainMenuElement {
    public visible = false;
    public text: string;
    public moduleName: string;

    constructor(
        public menu: string,
        public path: string,
        public icon: string,
        public permission?: string,
        public permissionFunction?: (userInfo?: any) => boolean,
        public pathParams?: (userInfo?: any) => any[],
        public isVisibleOnMobile?: boolean,
        public items?: MainMenuElement[],
        public queryParams?: {},
        public showAsBottomSheet?: boolean,
        public click?: () => void,
        public isAssetIcon?: boolean
    ) { }
}



export class DataGroupInfoHeader extends DataGroupInfo {
    constructor(
        public override Name: string,
        public override Value: string,
        public override TotalRows = 0,
    ) {
        super(Name, Value, TotalRows); 
    }
    public Toggle: EnumToggle = EnumToggle.Out;
    public DataSource: BaseDataSourceAbstract;
    public Items: BaseEntity[];
}



export class FieldInfo {
    constructor(
        public Name: string,
        public Translation: string) { }
}


export class MessageBoxCustomButton {
    Text: string;
    ButtonID: number;
    TabIndex?: number;
}

export class LoginExtensionLink {
    Name: string;
    Link: string;
    Type: EnumLoginExtensionLinkType;
    ModuleName: string;
}

export class DefaultRouteParams {
    Route: string = '';
    Params: any;
}

export class ToolbarSettings {
    PageComponentName: string;
    Page: BasePageComponent<BaseEntity, BaseState>;

    Title: string;
    Subtitle: string;
    SubtitleTemplate: TemplateRef<any>;

    ShowMenuButton: boolean;
    ShowBackButton: boolean;
    BackButtonClick: () => void;
    ViewModes: ViewModeElement[];
    ShowCloseButton: boolean;
    CloseButtonClick: () => void;
    OnGetPreviewTitle: () => string = () => '';

    OnGetContextMenuItems: () => ContextMenuElement[];
    ContextMenuTitle: string;
    ShowContextMenuAsUsualOnMobile: boolean = false;

    IsAllowFilter: boolean = false;
    IsAllowExport: boolean = false;
    IsAllowPrint: boolean = false;
    IsAllowShare: boolean = false;
    IsAllowNotifications: boolean = false;
    IsSupportHistory: boolean = false;
    ShowButtonsText: boolean = false;
    GridExtender: GridExtender | (() => GridExtender);

    FilterPanelWidth: EnumWindowSizes;

    OnPrintButtonClick: (e) => void;
    OnShareButtonClick: (e) => void;
    OnTitleClick: () => void;

    CustomFilterCssClass: string;
}

export class InjectableComponentOptions<TComponentType extends BaseInjectableComponent<BaseEntity, BaseState>> {
    TargetModuleName: string;
    TargetComponentName: string;
    TargetComponentType?: 'contact-us';
    ButtonText: string;
    ButtonIcon: string;
    ShowInToolbarOnMobile: boolean;
    IsVisibleButton: (page: BasePageComponent<BaseEntity, BaseState>) => boolean;
    ComponentType: (new (A: ServiceBagService, ComponentName: string, StateType: (new () => BaseState)) => TComponentType);
}

export class MessageBoxOptions {
    constructor(public Type: EnumMessageBoxTypes, public Prompt: string) {

    }
}

export class ShareableEntity {
    constructor(public PageType: EnumPrintingType, public EntityType: (new () => BaseEntity), public PageComponents: ((new (...args: any[]) => BaseComponent<BaseState>)) []) { }
}